An array of descriptions of the person's responsibilities, skills and achievements in the position.
